export const maritalItems = (t: any) => [
  {
    label: t`screens.personalDataAdditional.maritalStatusList.married`,
    value: "02",
  },
  {
    label: t`screens.personalDataAdditional.maritalStatusList.divorced`,
    value: "03",
  },
  {
    label: t`screens.personalDataAdditional.maritalStatusList.widowed`,
    value: "04",
  },
  {
    label: t`screens.personalDataAdditional.maritalStatusList.unmarried`,
    value: "06",
  },
  {
    label: t`screens.personalDataAdditional.maritalStatusList.separated`,
    value: "07",
  },
];

export const sectorActivityItems = (t: any) => [
  {
    label: t`screens.employmentsDetail.occupationList.adviceConsulting`,
    value: "11",
  },
  {
    label: t`screens.employmentsDetail.occupationList.accounting`,
    value: "6",
  },
  {
    label: t`screens.employmentsDetail.occupationList.agriculture`,
    value: "3",
  },
  {
    label: t`screens.employmentsDetail.occupationList.aircraft`,
    value: "2",
  },
  {
    label: t`screens.employmentsDetail.occupationList.armsAndNuclearTech`,
    value: "53",
  },
  {
    label: t`screens.employmentsDetail.occupationList.artAndAntiques`,
    value: "54",
  },
  {
    label: t`screens.employmentsDetail.occupationList.automobile`,
    value: "7",
  },
  {
    label: t`screens.employmentsDetail.occupationList.bankingFinancialServices`,
    value: "8",
  },
  {
    label: t`screens.employmentsDetail.occupationList.carBoatAirplaneDealing`,
    value: "51",
  },
  {
    label: t`screens.employmentsDetail.occupationList.chemistryPharma`,
    value: "9",
  },
  {
    label: t`screens.employmentsDetail.occupationList.commerceSales`,
    value: "10",
  },
  {
    label: t`screens.employmentsDetail.occupationList.construction`,
    value: "12",
  },
  { label: t`screens.employmentsDetail.occupationList.craft`, value: "4" },
  {
    label: t`screens.employmentsDetail.occupationList.creativeDesign`,
    value: "13",
  },
  {
    label: t`screens.employmentsDetail.occupationList.education`,
    value: "15",
  },
  {
    label: t`screens.employmentsDetail.occupationList.engineeringArchitecture`,
    value: "18",
  },
  {
    label: t`screens.employmentsDetail.occupationList.entertainmentMedia`,
    value: "29",
  },
  {
    label: t`screens.employmentsDetail.occupationList.financeEconomy`,
    value: "14",
  },
  {
    label: t`screens.employmentsDetail.occupationList.foodBeverage`,
    value: "17",
  },
  {
    label: t`screens.employmentsDetail.occupationList.gambling`,
    value: "55",
  },
  {
    label: t`screens.employmentsDetail.occupationList.healthMedicine`,
    value: "23",
  },
  {
    label: t`screens.employmentsDetail.occupationList.humanResources`,
    value: "26",
  },
  {
    label: t`screens.employmentsDetail.occupationList.informatics`,
    value: "20",
  },
  {
    label: t`screens.employmentsDetail.occupationList.insurance`,
    value: "5",
  },
  {
    label: t`screens.employmentsDetail.occupationList.marketing`,
    value: "22",
  },
  {
    label: t`screens.employmentsDetail.occupationList.moneyExchangeTransfer`,
    value: "52",
  },
  {
    label: t`screens.employmentsDetail.occupationList.preciousAndJewelry`,
    value: "16",
  },
  {
    label: t`screens.employmentsDetail.occupationList.publishServices`,
    value: "28",
  },
  {
    label: t`screens.employmentsDetail.occupationList.realEstate`,
    value: "19",
  },
  {
    label: t`screens.employmentsDetail.occupationList.researchAndDevelopment`,
    value: "25",
  },
  {
    label: t`screens.employmentsDetail.occupationList.security`,
    value: "27",
  },
  {
    label: t`screens.employmentsDetail.occupationList.transport`,
    value: "31",
  },
  {
    label: t`screens.employmentsDetail.occupationList.taxLegal`,
    value: "21",
  },
  {
    label: t`screens.employmentsDetail.occupationList.telecommunication`,
    value: "30",
  },
  { label: t`screens.employmentsDetail.occupationList.textile`, value: "24" },
  { label: t`screens.employmentsDetail.occupationList.tourism`, value: "32" },
  { label: t`screens.employmentsDetail.occupationList.other`, value: "1" },
];

export const occupationItems = (t: any) => [
  {
    text: t`screens.employmentsDetail.employed`,
    _value: "Employed",
  },
  {
    text: t`screens.employmentsDetail.freelancer`,
    _value: "Freelancer",
  },
];
